import { render, staticRenderFns } from "./controPage.vue?vue&type=template&id=58872b1e"
import script from "./controPage.vue?vue&type=script&lang=js"
export * from "./controPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports